import StudioUpgradeTarget from './StudioUpgradeTarget';

export default class SampleFirmwareUpgradeRequest {

    public firmwareRevisionId: number;
    public studioTargets: StudioUpgradeTarget[] = [];
    public targetReleaseVersion: string;
    public firmwareFileName: string;
    public immediate: boolean = false;

    constructor(data?: { [key: string]: any }) {
        this.firmwareRevisionId = data?.['firmwareRevisionId'];
        this.studioTargets = Array.isArray(data?.['studioTargets']) ? data['studioTargets']
            .map(studioTarget => studioTarget instanceof StudioUpgradeTarget ? studioTarget :
                new StudioUpgradeTarget(studioTarget)) : [];
        this.targetReleaseVersion = data?.['targetReleaseVersion'];
        this.firmwareFileName = data?.['firmwareFileName'];
        this.immediate = data?.['immediate'];
    }

}
